import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLazyQuery } from '@apollo/client';
import Config from 'config';
import KEY_ACTIVITIES_COMPLETED_REPORT_QUERY from 'graph/reports/key-activities-completed-report-async-query';
import { isEmpty, map } from 'lodash';
import useReportQueryParams from '../../../../hooks/use-report-query-params';
import BarChartCard, { ChartData } from '../../../../charts/BarChartCard';
import { getQueryVariables } from '../../../../utils/report-param-utils';

const ActivitiesCompletedChart: React.FC = () => {
  const { t } = useTranslation(['Reports', 'ReportsHelpCommon']);
  const [{ entityId, entityType, dateRange }] = useReportQueryParams();
  const [fetchReport, { data, error, stopPolling }] = useLazyQuery(
    KEY_ACTIVITIES_COMPLETED_REPORT_QUERY,
    {
      pollInterval: Config.reporting.asyncPollIntervalMs
    }
  );

  useEffect(() => {
    fetchReport({ variables: getQueryVariables({ entityId, entityType, dateRange }) as any });
  }, [fetchReport, entityId, entityType, dateRange]);

  const chartData: ChartData = {};

  if (error) {
    stopPolling?.();
  } else if (data?.keyActivitiesCompletedReportAsync?.result) {
    stopPolling?.();

    const {
      curriculumActivitiesCompleted = [],
      totalActivitiesCompletedCount
    } = data.keyActivitiesCompletedReportAsync.result;

    chartData.series = map(curriculumActivitiesCompleted, 'activitiesCompletedCount');
    chartData.categories = map(curriculumActivitiesCompleted, 'productCurriculumCode');
    chartData.total = totalActivitiesCompletedCount;
  }

  return (
    <BarChartCard
      title={t('Activities Completed')}
      yaxisTitle={t('Activities')}
      helpText={t('activitiesCompleted', { ns: 'ReportsHelpCommon' })}
      loading={isEmpty(chartData)}
      {...chartData}
    />
  );
};

export default React.memo(ActivitiesCompletedChart);
